//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ClientePagador',
  props: {
    pendencia: null,
  },
  data: () => ({
    menu: false,
  }),
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/ClientePagador.vue?vue&type=script&lang=js&